import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Stack,
  IconButton,
  useMediaQuery,
  Box,
  CircularProgress // ADD THIS IMPORT
} from '@mui/material';
import { Menu, Search } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useState } from 'react'; // ADD THIS IMPORT FOR STATE MANAGEMENT

export default function Header() {
  const isMobile = useMediaQuery('(max-width:900px)');
  
  // ADD STATE FOR LOADING
  const [howItWorksLoading, setHowItWorksLoading] = useState(false);

  // ADD CLICK HANDLER FUNCTION FOR "HOW IT WORKS" BUTTON
  const handleHowItWorksClick = () => {
    // Set loading state to true
    setHowItWorksLoading(true);
    
    // Simulate loading process (2 seconds)
    setTimeout(() => {
      // Check if we're on the landing page
      if (window.location.pathname === '/') {
        // If on landing page, scroll to the "How It Works" section
        const howItWorksSection = document.getElementById('how-it-works-section');
        if (howItWorksSection) {
          howItWorksSection.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      } else {
        // If not on landing page, navigate to landing page with hash
        window.location.href = '/#how-it-works-section';
      }
      
      // Reset loading state after navigation/scroll completes
      setTimeout(() => {
        setHowItWorksLoading(false);
      }, 500);
    }, 1500); // Simulate 1.5 seconds loading time
  };

  return (
    <AppBar 
      position="static" 
      color="secondary" 
      elevation={0}
      sx={{ 
        borderBottom: '1px solid',
        borderColor: 'divider',
        py: 1
      }}
    >
      <Toolbar>
        {/* Logo - Replaces PropertyEarn text */}
        <Box 
          component={Link}
          to="/"
          sx={{ 
            flexGrow: 1,
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            height: 40
          }}
        >
          <img 
            src="/images/logo.png" 
            alt="PropertyEarn Logo" 
            style={{ 
              height: '35px',
              width: 'auto',
              objectFit: 'contain',
              mixBlendMode: 'multiply', // Blends with background color
              filter: 'brightness(3.3) contrast(- 1.4)' // Increases brightness of logo contents
            }}
          />
        </Box>

        {/* Desktop Navigation */}
        {!isMobile && (
          <Stack direction="row" spacing={3} sx={{ mr: 3 }}>
            {/* MODIFIED: How It Works Button with Loading State */}
            <Button 
              color="inherit"
              onClick={handleHowItWorksClick} // Use onClick instead of Link
              disabled={howItWorksLoading} // Disable button during loading
              sx={{ 
                minWidth: '120px', // Ensure consistent width
                position: 'relative'
              }}
            >
              {howItWorksLoading ? (
                // Show loading spinner when loading
                <CircularProgress 
                  size={24} 
                  color="inherit" 
                  sx={{
                    color: 'white'
                  }}
                />
              ) : (
                // Show normal text when not loading
                'How It Works'
              )}
            </Button>
          </Stack>
        )}

        {/* Auth Buttons */}
        <Stack direction="row" spacing={2} alignItems="center">
          <Button 
            color="inherit"
            component={Link}
            to="/login"
            sx={{ 
              border: '1px solid rgba(255,255,255,0.3)',
              px: 3
            }}
          >
            Login
          </Button>
          <Button 
            variant="contained"
            color="primary"
            component={Link}
            to="/signup"
            sx={{ 
              px: 3,
              fontWeight: 600,
              '&:hover': {
                bgcolor: 'primary.dark'
              }
            }}
          >
            Sign Up
          </Button>
        </Stack>

        {/* Mobile Menu Button */}
        {isMobile && (
          <IconButton 
            color="inherit" 
            sx={{ ml: 2 }}
            aria-label="menu"
          >
            <Menu />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  );
}